import React, {useState} from 'react';
import {Avatar as MantineAvatar, AvatarProps as MantineAvatarProps} from '@mantine/core';

export type AvatarSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

const sizeMap: Record<AvatarSize, number> = {
    xs: 32,
    sm: 48,
    md: 80,
    lg: 120,
    xl: 160,
};

type AvatarProps = {
    src?: string | null;
    userName: string;
    size?: AvatarSize;
    style?: React.CSSProperties;
    onImageError?: () => void;
} & Omit<MantineAvatarProps, 'size' | 'src'>;

export const Avatar = ({
    src,
    userName,
    size = 'md',
    style,
    onImageError,
    ...mantineProps
}: AvatarProps) => {
    const sizeValue = sizeMap[size];
    const [imgSrc, setImgSrc] = useState(src);

    React.useEffect(() => {
        setImgSrc(src);
    }, [src]);

    const handleError = () => {
        setImgSrc(null);
        onImageError?.();
    };

    return (
        <MantineAvatar
            src={imgSrc}
            size={sizeValue}
            radius="md"
            style={style}
            onError={handleError}
            {...mantineProps}
        >
            {userName.charAt(0).toUpperCase()}
        </MantineAvatar>
    );
};
